import axios from "axios";

function BranchDropdownSpecial() {
  return new Promise((resolve, reject) => {
    axios
      .get("/account/api/v1/nodes/me-bottom-dropdown-special")
      .then(response => {
        return resolve(response.data);
      })
      .catch(error => {
        return reject(error.response.data);
      });
  });
};

export default BranchDropdownSpecial;